import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { AuthRepository } from "./auth.repository";
import { ChangePasswordRequest, LoginRequest, LoginResponse } from "../models/login.model";

@Injectable({providedIn: 'root'})
export class AuthApiRepository extends AuthRepository {
    constructor(private http: HttpClient){
        super();
    }

    override login(request: LoginRequest): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(
      `${environment.apiUrl}/sales/admin/login`,
      request
    );
    }

    override changePassword(request: ChangePasswordRequest): Observable<any> {
      return this.http.post<any>(
        `${environment.apiUrl}/sales/admin/change-password` , request
      )
    }
}

